import debug from "debug";
import environment from "src/utils/environment";

window.localStorage.debug = environment.debugMode
  ? environment.debuggers
  : "-*";

const prefix = "ttm:";

const createDebug = (name) => {
  return debug(prefix + name);
};

const logNames = [
  "activityEmitter",
  "activityLog",
  "audioProcessing",
  "auth",
  "babyStation",
  "dataChannel",
  "device",
  "deviceDiscovery",
  "error",
  "general",
  "lullaby",
  "messenger",
  "pairing",
  "parentStation",
  "pingPong",
  "protoBuffers",
  "purchase",
  "pushNotification",
  "rtcManager",
  "signaling",
  "synchronizer",
  "xmpp",
  "scheduler"
];

export default logNames.reduce((accu, name) => {
  accu[name] = createDebug(name);
  return accu;
}, {});
